<template>
  <v-dialog v-model="isActive" width="500">
    <v-card>
      <v-toolbar dense color="black" :dark="true">
        <v-toolbar-title>Seleccione</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid class="d-flex flex-column">
        <v-row v-if="tipeOption === 'filenameFormat'" justify="center">
          <v-col>
            <div>Seleccione su <strong>formato</strong> de audio:</div>
            <v-select
              v-model="selectfilenameFormat"
              class="mt-4"
              item-value="id"
              :items="filenameFormatList"
              :item-text="(items) => `${items.name} - ${items.filename_format}`"
              label="Seleccione..."
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="tipeOption === 'storage'" justify="center">
          <v-col>
            <div>Seleccione su <strong>storage</strong>:</div>
            <v-select
              v-model="selectStorage"
              class="mt-4"
              item-value="id"
              :items="listStorage"
              :item-text="
                (items) => `${items.nameBucket} - ${items.providerName}`
              "
              label="Seleccione..."
              solo
            ></v-select>
            <v-select
              v-model="selectfilenameFormat"
              class="mt-4"
              item-value="id"
              :items="filenameFormatList"
              :item-text="(items) => `${items.name} - ${items.filename_format}`"
              label="Seleccione..."
              solo
            ></v-select>
          </v-col>
        </v-row>
        <div class="my-4 d-flex justify-space-around">
          <v-btn tile :disabled="isValidDownloads" outlined @click="save()">
            Descargar
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-autorenew</v-icon>
              </span>
            </template>
          </v-btn>
          <v-btn tile outlined @click="closeModal()">
            Cancel
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    tipeOption: String,
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    selectStorage: "",
    selectfilenameFormat: "",
  }),
  methods: {
    closeModal() {
      this.resetVariables();
      this.isActive = false;
      this.$emit("close");
    },
    save() {
      const json = {
        customerAudioFormatId: this.selectfilenameFormat,
        customerStorageId: this.selectStorage,
      };
      this.resetVariables();
      this.isActive = false;
      this.$emit("save", json);
    },
    resetVariables() {
      (this.selectfilenameFormat = ""), (this.selectStorage = "");
    },
  },
  computed: {
    ...mapGetters("filenameFormat", {
      filenameFormatList: "filenameFormatTable",
    }),
    ...mapGetters("storage", { listStorage: "storageTable" }),
    isValidDownloads() {
      if (
        (this.tipeOption === "filenameFormat" &&
          this.selectfilenameFormat != "") ||
        (this.tipeOption === "storage" &&
          this.selectStorage != "" &&
          this.selectfilenameFormat != "")
      ) {
        return false;
      }
      return true;
    },
  },
  created() {
    this.$store.dispatch("filenameFormat/getFilenameFormat");
    this.$store.dispatch("storage/getAllStorage");
  },
};
</script>

<style></style>
